<template>
  <nav
    id="secondarybar"
    class="topbar is-flex is-align-items-center"
    data-test="navbar-desktop-overview-bar"
    style="height: 40px;">
    <a
      class="has-text-weight-semibold is-size-5 is-flex is-align-items-center has-background-white px-4"
      style="height: 100%"
      @click="show_project_sidebar = true">
      {{ $t('navbar.employee.all_projects') }}
    </a>

    <div class="topbar-divider"/>

    <ul v-if="mq.isDesktop" class="is-flex is-align-items-center ml-2">
      <NavbarItemHorizontal
        v-for="(item, idx) in navigation_items"
        :key="idx"
        class="mr-5"
        :item="item"/>
    </ul>

    <div v-else>
      <div class="p-2 cursor-pointer hover:text-gray-500" @click="toggle">
        <FontAwesomeIcon
          :icon="['far','bars']"
          size="lg"/>
      </div>

      <PMenu id="overlay_menu" ref="menu" :model="navigation_items" :popup="true">
        <template #item="{ item, props }">
          <NavbarItemHorizontal
            v-bind="props.action"
            :item="item"/>
        </template>
      </PMenu>
    </div>

    <TheProjectSideBar
      :show_project_sidebar="show_project_sidebar"
      @closeProjectSidebar="show_project_sidebar = false"/>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { useMqService } from '@/plugins/mq';
import {
  NAVBAR_ITEMS_EMPLOYEES_OVERVIEW_NAVBAR
} from '@/app/data/navbar_constants';
import NavbarItemHorizontal from '@/app/shared_components/navbar/NavbarItemHorizontal.vue';
import TheProjectSideBar from '@/app/_employees/components/sidebars/TheProjectSideBar.vue';

export default {
  name: 'TheNavbarDesktopClientHorizontalOverview',
  components: {
    NavbarItemHorizontal,
    TheProjectSideBar
  },

  setup() {
    const mq = useMqService();
    return { mq };
  },

  data() {
    return {
      show_project_sidebar: false
    };
  },

  computed: {
    ...mapGetters(['current_client', 'current_project']),
    navigation_items() {
      return _.filter(NAVBAR_ITEMS_EMPLOYEES_OVERVIEW_NAVBAR, this.isRouteActive);
    }
  },

  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    isRouteActive(route) {
      if (route.flipper) {
        return this.$flipper.enabled(route.flipper);
      }

      return true
    }
  }
};
</script>
